import { ComponentPropsWithoutRef } from "react";

import { IIconProps } from "@/components/icons/IconInterface";

export const ProfileIcon = ({ size, color, isFilled, ...props }: ComponentPropsWithoutRef<"svg"> & IIconProps) => {
    if (isFilled) {
        return (
            <svg
                width={ size || 24 }
                height={ size || 24 }
                viewBox="0 0 512 512"
                version="1.1"
                preserveAspectRatio="xMidYMid"
                xmlSpace="preserve"
                { ...props }
            >
                <g>
                    <path
                        d="M256 0c-74.439 0-135 60.561-135 135s60.561 135 135 135 135-60.561 135-135S330.439 0 256 0zM423.966 358.195C387.006 320.667 338.009 300 286 300h-60c-52.008 0-101.006 20.667-137.966 58.195C51.255 395.539 31 444.833 31 497c0 8.284 6.716 15 15 15h420c8.284 0 15-6.716 15-15 0-52.167-20.255-101.461-57.034-138.805z"
                        fill={ color || "currentColor" }
                    ></path>
                </g>
            </svg>
        );
    }

    return (
        <svg
            width={ size || 24 }
            height={ size || 24 }
            viewBox="0 0 511 511.999"
            version="1.1"
            preserveAspectRatio="xMidYMid"
            xmlSpace="preserve"
            { ...props }
        >
            <g>
                <path
                    d="M256 0c-74.439 0-135 60.561-135 135s60.561 135 135 135 135-60.561 135-135S330.439 0 256 0zm0 240c-57.897 0-105-47.103-105-105S198.103 30 256 30s105 47.103 105 105-47.103 105-105 105zM423.966 358.195C387.006 320.667 338.009 300 286 300h-60c-52.008 0-101.006 20.667-137.966 58.195C51.255 395.539 31 444.833 31 497c0 8.284 6.716 15 15 15h420c8.284 0 15-6.716 15-15 0-52.167-20.255-101.461-57.034-138.805zM61.66 482c7.515-85.086 78.351-152 164.34-152h60c85.989 0 156.825 66.914 164.34 152H61.66z"
                    fill={ color || "currentColor" }
                ></path>
            </g>
        </svg>
    );
};
